import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Charts from "../Echarts";
import NegativeMarket from "../../../utils/m4k/bat_data/NegativeMarket";
import NegativeUse from "../../../utils/m4k/bat_data/NegativeUse";
import NegativePriceTrend from "../../../utils/m4k/bat_data/NegativePriceTrend";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mapLeft: {
      padding: "0 20px",
    },
  })
);

const BatRight: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.mapLeft}>
      <Grid item xs={12}>
        <Charts
          option={NegativeMarket}
          style={{
            height: "30vh",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Charts
          option={NegativeUse}
          style={{
            height: "calc(30vh - 20px)",
            margin: "10px 0",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Charts option={NegativePriceTrend} style={{ height: "29vh" }} />
      </Grid>
    </Grid>
  );
};

export default BatRight;
